import { writable } from "svelte/store";
import { assoc, batch } from "@welshman/lib";
import { withGetter } from "@welshman/store";
export const freshness = withGetter(writable({}));
export const getFreshnessKey = (ns, key) => `${ns}:${key}`;
export const getFreshness = (ns, key) => freshness.get()[getFreshnessKey(ns, key)] || 0;
export const setFreshnessImmediate = ({ ns, key, ts }) => freshness.update(assoc(getFreshnessKey(ns, key), ts));
export const setFreshnessThrottled = batch(100, (updates) => freshness.update($freshness => {
    for (const { ns, key, ts } of updates) {
        $freshness[getFreshnessKey(ns, key)] = ts;
    }
    return $freshness;
}));
//# sourceMappingURL=freshness.js.map